import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * Action to update the calendar display order
 */
export const updateCalendarDisplayOrder = action(
    'updateCalendarDisplayOrder',
    (
        userIdentity: string,
        draggedCalendarId: string,
        prevCalendarId: string,
        nextCalendarId: string,
        destParentGroupId: string
    ) =>
        addDatapointConfig(
            {
                name: 'UpdateCalendarDisplayOrder',
            },
            {
                userIdentity,
                draggedCalendarId,
                prevCalendarId,
                nextCalendarId,
                destParentGroupId,
            }
        )
);
